// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.inventory.item.ItemQuantityChangeResponse */
/* istanbul ignore next */
@GandalfModel
export class ItemQuantityChangeResponse extends GandalfModelBase {

	@GandalfProperty({ designType: String })
	changeReason!: string | null;

	@GandalfProperty({ designType: String })
	changeType!: string | null;

	@GandalfProperty({ designType: String })
	comments!: string | null;

	@GandalfProperty({ designType: String })
	createdByUserName!: string | null;

	@GandalfProperty({ designType: Date })
	createdOn!: Date | null;

	@GandalfProperty({ designType: Number })
	id!: number | null;

	@GandalfProperty({ designType: Number })
	quantityChange!: number | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	unitCost!: number | null;

}
